// import { ReactComponent as FrameSVG } from "./frame.svg";

import { useState, useRef, useEffect } from "react";
import beat1 from "./beat1.jpg";
import beat0 from "./beat0.PNG";  
import beat2 from "./assets/image/beat2.jpg";
import beat3 from "./assets/image/IMG_0857.jpg";
import beat4 from "./assets/image/IMG_0859.jpg";
import beat5 from "./assets/image/IMG_0418.jpg";
import beat6 from "./assets/image/IMG_0879.jpg";
import beat7 from "./assets/image/IMG_0880.jpg";
import beat8 from "./assets/image/IMG_0855.jpg";
import beat9 from "./assets/image/church.png";
import beat10 from "./assets/image/Lights out.jpg";
import beat11 from "./assets/image/Ghost bride.jpg";
import beat12 from "./assets/image/don't f w us.jpg";
import beat13 from "./assets/image/In my dreams.png";
import beat14 from "./assets/image/Apocalypse III.png";
import beat15 from "./assets/image/addiction.png";
import beat16 from "./assets/image/Old friends.JPG";
import beat17 from "./assets/image/Golden grills.png";
import beat18 from "./assets/image/poison treat.jpg";
import beat19 from "./assets/image/Hmmyto$.png";
import beat20 from "./assets/image/Slimey alley.jpg";
import beat21 from "./assets/image/death race.png";
import beat22 from "./assets/image/consumption by rage.jpg";
import beat23 from "./assets/image/Spliff the kif.jpg";
import beat24 from "./assets/image/clean flight.jpg";

import beat1wav from "./assets/audio/Submerge.wav";
import beat2wav from "./assets/audio/nebula.wav";
import beat3wav from "./assets/audio/bloodface.wav";
import beat4wav from "./assets/audio/Apocalypse I.wav";
import beat5wav from "./assets/audio/Some We Forget.wav";
import beat6wav from "./assets/audio/Apocalypse II.wav";
import beat7wav from "./assets/audio/Athens Catacombs.wav";
import beat8wav from "./assets/audio/Brutality2.wav";
import beat9wav from "./assets/audio/Redroom.wav";
import beat$1wav from "./assets/audio/10$/Doubleblade.wav";
import beat$2wav from "./assets/audio/10$/Plastic Palm Trees.wav";
import beat$3wav from "./assets/audio/10$/Night Car Chase.wav";
import beat$4wav from "./assets/audio/10$/Cyan Blue Grinder.wav";
import beat$5wav from "./assets/audio/10$/Execution.wav";
import beat$6wav from "./assets/audio/10$/Smoke with the Reaper.wav";
import beat$7wav from "./assets/audio/vol2/lights out.wav";
import beat$8wav from "./assets/audio/vol2/Ghost bride.wav";
import beat$9wav from "./assets/audio/vol2/don't f w us.wav";
import beat$10wav from "./assets/audio/vol2/In my dreams.wav";
import beat$11wav from "./assets/audio/vol2/Apocalypse III.wav";
import beat$12wav from "./assets/audio/vol2/addiction.wav";
import beat$13wav from "./assets/audio/vol2/Old friends.wav";
import beat$14wav from "./assets/audio/vol2/Golden grills.wav";
import beat$15wav from "./assets/audio/vol2/poison treat.wav";
import beat$16wav from "./assets/audio/vol2/Hmmyto$.wav";
import beat$17wav from "./assets/audio/vol2/Slimey alley.wav";
import beat$18wav from "./assets/audio/vol2/death race.wav";
import beat$19wav from "./assets/audio/vol2/consumption by rage.wav";
import beat$20wav from "./assets/audio/vol2/spliff the kif.wav";
import beat$21wav from "./assets/audio/vol2/clean flight.wav";

const PINK = "#f8c0fa";
const BLACK = "#000000";
const RED = "#ffffff" 

const beats = [
  { id: 1, title: "Apocalypse I", bpm: 140, key: "F# Min", tag: "apocalypse", audioUrl: beat4wav , imageUrl:beat4 },
  { id: 2, title: "Nebula", bpm: 140, key: "F# Min", tag: "distorted wavy", audioUrl: beat2wav , imageUrl:beat2 },
  { id: 3, title: "Bloodface", bpm: 140, key: "F# Min", tag: "New age Hard", audioUrl: beat3wav , imageUrl:beat3 },
  { id: 4, title: "Submerge", bpm: 140, key: "F# Min", tag: "nostalgic", audioUrl: beat1wav , imageUrl:beat5 },
  { id: 5, title: "Apocalypse II", bpm: 140, key: "F# Min", tag: "apocalypse", audioUrl: beat6wav , imageUrl:beat8 },  
  { id: 6, title: "Athens Catacombs", bpm: 140, key: "F# Min", tag: "horrorcore", audioUrl: beat7wav , imageUrl:beat6 },
  { id: 7, title: "Redroom", bpm: 140, key: "F# Min", tag: "old school mysterious", audioUrl: beat9wav , imageUrl:beat7 },
  { id: 8, title: "Brutality", bpm: 140, key: "F# Min", tag: "horrorcore", audioUrl: beat8wav , imageUrl:beat9 },
  { id: 9, title: "Some We Forget", bpm: 140, key: "F# Min", tag: "sad rythmic", audioUrl: beat5wav , imageUrl:beat1 },
  { id: 10, title: "Lights out", bpm: 140, key: "F# Min", tag: "New age dark", audioUrl: beat$7wav , imageUrl:beat10 },
  { id: 11, title: "Ghost bride", bpm: 140, key: "F# Min", tag: "old school dark", audioUrl: beat$8wav , imageUrl:beat11 },
  { id: 12, title: "Don't f w us", bpm: 140, key: "F# Min", tag: "hard trap", audioUrl: beat$9wav , imageUrl:beat12 },
  { id: 13, title: "In my dreams", bpm: 140, key: "F# Min", tag: "nostalgic wavy", audioUrl: beat$10wav , imageUrl:beat13 },
  { id: 14, title: "Apocalypse III", bpm: 140, key: "F# Min", tag: "apocalypse", audioUrl: beat$11wav , imageUrl:beat14 },
  { id: 15, title: "Addiction", bpm: 140, key: "F# Min", tag: "hard trap", audioUrl: beat$12wav , imageUrl:beat15 },
  { id: 16, title: "Old friends", bpm: 140, key: "F# Min", tag: "nostalgic", audioUrl: beat$13wav , imageUrl:beat16 },
  { id: 17, title: "Golden grills", bpm: 140, key: "F# Min", tag: "chill atmospheric", audioUrl: beat$14wav , imageUrl:beat17 },
  { id: 18, title: "Poison treat", bpm: 140, key: "F# Min", tag: "atmospheric trap", audioUrl: beat$15wav , imageUrl:beat18 },
  { id: 19, title: "Hmmyto$", bpm: 140, key: "F# Min", tag: "jazz trap", audioUrl: beat$16wav , imageUrl:beat19 },
  { id: 20, title: "Slimey alley", bpm: 140, key: "F# Min", tag: "Horrorcore", audioUrl: beat$17wav , imageUrl:beat20 },
  { id: 21, title: "Death race", bpm: 140, key: "F# Min", tag: "hard trap", audioUrl: beat$18wav , imageUrl:beat21 },
  { id: 22, title: "Consumpion by rage", bpm: 140, key: "F# Min", tag: "New age hard", audioUrl: beat$19wav , imageUrl:beat22 },
  { id: 23, title: "Spliff the kif", bpm: 140, key: "F# Min", tag: "chill", audioUrl: beat$20wav , imageUrl:beat23 },
  { id: 24, title: "Clean flight", bpm: 140, key: "F# Min", tag: "Atmospheric trap", audioUrl: beat$21wav , imageUrl:beat24 },
];

const noStemBeats = [
  { id: 101, title: "Doubleblade", bpm: 138, key: "A Min", tag: "psychedelic hard", audioUrl: beat$1wav },
  { id: 102, title: "Plastic Palm Trees", bpm: 145, key: "D Min", tag: "chill sentimental", audioUrl: beat$2wav },
  { id: 103, title: "Night Car Chace", bpm: 130, key: "G# Min", tag: "aggrrrrresive", audioUrl: beat$3wav },
  { id: 104, title: "Cyan Blue Grinder", bpm: 142, key: "B Min", tag: "listen while high", audioUrl: beat$4wav },
  { id: 105, title: "Execution", bpm: 136, key: "E Min", tag: "dark drill", audioUrl: beat$5wav },
  { id: 106, title: "Smoke with the Reaper", bpm: 136, key: "E Min", tag: "dark trap", audioUrl: beat$6wav },
];

function GothicFrame({ children, playing }) {
  return (
    <div style={{ position: "relative", width: "100%"}}>
      {children}
      {/* Dark blue frame overlay using SVG as a mask */}
    {/* <div
  style={{
    position: "absolute",
    inset: 0,                 
    WebkitMaskImage: `url(${frameUrl})`,
    maskImage: `url(${frameUrl})`,
    WebkitMaskSize: "100% 100%",
    maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    backgroundColor: "#1f2849",
    opacity: 1,
    pointerEvents: "none",
    zIndex: 2,
  }}
/> */}
    </div>
  );
}
function BeatCard({ beat, currentlyPlaying, setCurrentlyPlaying }) {
  const [hovered, setHovered] = useState(false);
  const audioRef = useRef(null);
  const isPlaying = currentlyPlaying === beat.id;

  useEffect(() => {
    if (beat.audioUrl) {
      const audio = new Audio(beat.audioUrl);
      audio.loop = true;
      audioRef.current = audio;
    }
    return () => { if (audioRef.current) audioRef.current.pause(); };
  }, [beat.audioUrl]);

  useEffect(() => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.play().catch(() => {});
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, [isPlaying]);

  const togglePlay = () => {
    if (!audioRef.current) return;
    setCurrentlyPlaying(isPlaying ? null : beat.id);
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      // style={{ display: "flex", flexDirection: "column", gap: "14px", maxWidth: "100%" }}
      style={{ display: "flex", flexDirection: "column", gap: "14px", width: "100%", maxWidth: "100%" }}
    >
      <GothicFrame playing={isPlaying}>
        <div style={{ width: "100%", aspectRatio: "1 / 1", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {/* <img src={beat.imageUrl} style={{ width: "100%" }} alt={beat.title} /> */}
          <img
  src={beat.imageUrl}
  alt={beat.title}
  style={{
    width: "100%",
    height: "100%",
    objectFit: "cover"
  }}
/>
          {/* {isPlaying && (
            <div style={{ display: "flex", gap: "4px", alignItems: "flex-end", height: "40px", position: "absolute" ,}}>
              {Array.from({ length: beats.length }).map((_, i) => (
                <div key={i} style={{ width: "4px", background: PINK, animation: `barPulse ${0.4 + i * 0.08}s ease-in-out infinite alternate`, height: `${20 + (i % 3) * 12}px` }} />
              ))}
            </div>
          )} */}
          <button
            onClick={togglePlay}
            style={{
              position: "absolute", bottom: "12px", right: "12px", width: "40px", height: "40px",
              background: BLACK, border: "none", color: PINK, cursor: "pointer",
              clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
              opacity: hovered || isPlaying ? 1 : 0.7,
            }}
          >{isPlaying ? "■" : "▶"}</button>
        </div>
      </GothicFrame>
      <div>
        <div style={{ fontSize: "10px", fontWeight: "bold", letterSpacing: "2px", textTransform: "uppercase" }}>{beat.title}</div>
        <div style={{ fontSize: "10px", opacity: 0.4, border: `1px solid rgba(0,0,0,0.25)`, display: "inline-block", padding: "2px 8px", marginTop: "4px" }}>{beat.tag}</div>
      </div>
    </div>
  );
}

// Row-style beat for the $10 section
function BeatRow({ beat, currentlyPlaying, setCurrentlyPlaying }) {
  const [hovered, setHovered] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const isPlaying = currentlyPlaying === beat.id;

  useEffect(() => {
    const audio = new Audio(beat.audioUrl);
    audio.loop = true;
    audioRef.current = audio;

    audio.addEventListener("loadedmetadata", () => setDuration(audio.duration));
    const tick = () => setProgress(audio.currentTime);
    audio.addEventListener("timeupdate", tick);

    return () => {
      audio.pause();
      audio.removeEventListener("timeupdate", tick);
    };
  }, [beat.audioUrl]);

  useEffect(() => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.play().catch(() => {});
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setProgress(0);
    }
  }, [isPlaying]);

  const togglePlay = () => setCurrentlyPlaying(isPlaying ? null : beat.id);

  const handleSeek = (e) => {
    if (!audioRef.current || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    const newTime = ratio * duration;
    audioRef.current.currentTime = newTime;
    setProgress(newTime);
  };

  const pct = duration ? (progress / duration) * 100 : 0;

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        padding: "12px 0",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        transition: "background 0.2s",
        background: hovered ? "rgba(248,192,250,0.04)" : "transparent",
        borderRadius: "2px",
      }}
    >
      {/* Play/Pause Button — hexagon via SVG background */}
      <div style={{ flexShrink: 0, position: "relative", width: "38px", height: "38px" }}>
        <svg width="38" height="38" viewBox="0 0 38 38" style={{ position: "absolute", top: 0, left: 0 }}>
          <polygon
            points="19,1 37,10 37,28 19,37 1,28 1,10"
            fill={isPlaying ? PINK : "transparent"}
            stroke={isPlaying ? PINK : "rgba(255,255,255,0.3)"}
            strokeWidth="1.5"
            style={{ transition: "all 0.2s" }}
          />
        </svg>
        <button
          onClick={togglePlay}
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "38px",
            height: "38px",
            background: "transparent",
            border: "none",
            color: isPlaying ? BLACK : "rgba(255,255,255,0.8)",
            cursor: "pointer",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "color 0.2s",
          }}
        >
          {isPlaying
            ? <svg width="10" height="10" viewBox="0 0 10 10"><rect x="0" y="0" width="10" height="10" fill={BLACK}/></svg>
            : <svg width="10" height="11" viewBox="0 0 10 11"><polygon points="0,0 10,5.5 0,11" fill="rgba(255,255,255,0.85)"/></svg>
          }
        </button>
      </div>

      {/* Title + Tag */}
      <div style={{ flexShrink: 0, width: "130px" }}>
        <div style={{ fontSize: "11px", fontWeight: "bold", letterSpacing: "2px", textTransform: "uppercase", color: isPlaying ? PINK : "white" }}>
          {beat.title}
        </div>
        <div style={{ fontSize: "9px", opacity: 0.35, letterSpacing: "1px", marginTop: "3px" }}>{beat.tag}</div>
      </div>

      {/* Progress Bar */}
      <div
        onClick={handleSeek}
        style={{
          flex: 1,
          height: "3px",
          background: "rgba(255,255,255,0.12)",
          cursor: "pointer",
          position: "relative",
          borderRadius: "2px",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            background: isPlaying ? PINK : "rgba(255,255,255,0.3)",
            borderRadius: "2px",
            transition: "background 0.3s",
          }}
        />
        {/* Scrubber dot */}
        {isPlaying && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: `${pct}%`,
              transform: "translate(-50%, -50%)",
              width: "8px",
              height: "8px",
              background: PINK,
              borderRadius: "50%",
              boxShadow: `0 0 6px ${PINK}`,
            }}
          />
        )}
      </div>

      {/* Time */}
      <div style={{ flexShrink: 0, fontSize: "9px", opacity: 0.4, letterSpacing: "1px", minWidth: "38px", textAlign: "right" }}>
        {fmt(progress)} / {fmt(duration)}
      </div>
    </div>
  );
}

export default function App() {
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);

  return (
    <div
      style={{
        position: "fixed",
        minHeight: "100vh",
        width: "100%",
        color: RED,
        backgroundColor: BLACK,
        backgroundImage: `url(${beat0})`,
        backgroundSize: "20rem",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        overflow: "hidden",
      }}
    >
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        ::-webkit-scrollbar { width: 5px; }
        ::-webkit-scrollbar-thumb { background: ${BLACK}; }
        @keyframes barPulse {
          from { transform: scaleY(0.4); }
          to { transform: scaleY(1); }
        }
      `}</style>

      <section style={{ padding: "50px 52px", textAlign: "center" }}>
        <h1 style={{ fontFamily:"Rubik Distressed", fontSize: "clamp(32px, 5vw, 58px)", letterSpacing: "8px" }}>akydonacid</h1>
        <div style={{ marginTop: "18px", fontSize: "11px", letterSpacing: "2px", opacity: 0.55 }}>
          <a href="mailto:akydonacid@gmail.com" style={{ color: RED, textDecoration: "none" }}>
            beats & production — akydonacid@gmail.com
          </a>
        </div>
        <div style={{ marginTop: "28px", display: "flex", justifyContent: "center", gap: "28px", flexWrap: "wrap", fontSize: "12px", letterSpacing: "2px", opacity: 0.65 }}>
          <a href="https://instagram.com/akydonacid?igsh=MXJhZno0OTFF3cnUzZw%3D%3D&ut-m_source=qr" target="_blank" rel="noreferrer" style={{ color: RED, textDecoration: "none", borderBottom: "1px solid rgba(255,255,255,0.3)", paddingBottom: "2px" }}>INSTAGRAM</a>
          <a href="https://open.spotify.com/artist/4BVVo7LTo2FU6Yf9WMHKGl?si=pXA7UNhyR9OuhR7B37OfJw" target="_blank" rel="noreferrer" style={{ color: RED, textDecoration: "none", borderBottom: "1px solid rgba(255,255,255,0.3)", paddingBottom: "2px" }}>SPOTIFY</a>
        </div>
      </section>

      {/* Scrollable area containing BOTH sections */}
      <section style={{padding: "0px 12px 80px 12px", height: "70vh", overflow: "auto" }}>

        {/* Original grid beats */}
        <div style={{ display: "grid", gap: "10px", gridTemplateColumns: "repeat(4, 1fr)", justifyItems: "stretch" }}>
          {beats.map((beat) => (
            <BeatCard key={beat.id} beat={beat} currentlyPlaying={currentlyPlaying} setCurrentlyPlaying={setCurrentlyPlaying} />
          ))}
        </div>

        {/* $10 Beats — No Stems */}
        <div style={{ marginTop: "64px" }}>
          {/* Section Header */}
          <div style={{ marginBottom: "24px", display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ flex: 1, height: "1px", background: "rgba(255,255,255,0.12)" }} />
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "11px", letterSpacing: "5px", textTransform: "uppercase", opacity:1, fontWeight: "bold" }}>
                $10 old beats (no stems)
              </div>
        
            </div>
            <div style={{ flex: 1, height: "1px", background: "rgba(255,255,255,0.12)" }} />
          </div>

          {/* Beat Rows */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {noStemBeats.map((beat) => (
              <BeatRow key={beat.id} beat={beat} currentlyPlaying={currentlyPlaying} setCurrentlyPlaying={setCurrentlyPlaying} />
            ))}
          </div>
        </div>

      </section>
    </div>
  );
}